import { render, staticRenderFns } from "./ZoneIcon.vue?vue&type=template&id=79d2f24a&"
import script from "./ZoneIcon.vue?vue&type=script&lang=js&"
export * from "./ZoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports